import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import { useSnackbar } from 'notistack';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { type ApiKey } from '../../../../../types/apiTypes';

const SuccessValueDiv = styled.div`
    margin-top: 24px;
`;

const ApiSecretDiv = styled.div`
    display: flex;
    align-items: center;
`;

const ApiSecretTextDiv = styled.div`
    display: block;
`;

const CopyButton = styled(Button)`
    margin-left: 10px;
`;

interface SuccessDialogProps {
    open: boolean;
    handleClose: () => void;
    createdKey: ApiKey | null;
    secret: string;
}

const SuccessDialog: React.FC<SuccessDialogProps> = ({ open, handleClose, createdKey, secret }) => {
    const { t } = useTranslation('admin_settings');
    const { enqueueSnackbar } = useSnackbar();

    const copySecret = () => {
        navigator.clipboard.writeText(secret);
        enqueueSnackbar(t('copied'), { variant: 'success' });
    };

    return (
        <Dialog
            open={open}
            onClose={handleClose}
        >
            <DialogTitle>{t('api-keys.new-api-key')}</DialogTitle>
            <DialogContent>
                <Typography>
                    {t('api-keys.success-copy-reminder')}
                </Typography>
                <SuccessValueDiv>
                    <Typography variant='body1'>{t('api-keys.api-key')}</Typography>
                    <Typography variant='body2'>{createdKey?.name}</Typography>
                </SuccessValueDiv>
                <SuccessValueDiv>
                    <ApiSecretDiv>
                        <ApiSecretTextDiv>
                            <Typography variant='body1'>{t('api-keys.api-secret')}</Typography>
                            <Typography variant='body2'>{secret}</Typography>
                        </ApiSecretTextDiv>
                        <CopyButton onClick={copySecret} variant='contained'>{t('copy')}</CopyButton>
                    </ApiSecretDiv>
                </SuccessValueDiv>

            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} variant='outlined'>{t('close')}</Button>
            </DialogActions>
        </Dialog>
    );
};

export default SuccessDialog;
